
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { officeaAplicacionComponent }    from '../officeAplicacion/officeApp.component'

const SECURITY_ROUTES: Routes = [
  { path: 'security/officeAplicacion', component: officeaAplicacionComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class OfficeAplicacionRoutingModule {}
